import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Ubuntu's app management better than Apple's",
  "description": "",
  "published": "2011-04-30T00:00:00.000Z",
  "redirect_from": ["/blog/ubuntu-better-for-app-management-than-apple/swizec/1672"],
  "categories": "AppStore, IOS (Apple), iTunes, Linux, MacOS, OpenSource, Ubuntu, Ubuntu Software Center, Uncategorized",
  "hero": "./img/ta9e5.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago I wrote about `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/even-with-narwhals-ubuntu-is-still-a-bitch-to-install/swizec/1638",
        "title": "Even with Narwhals ubuntu is still a bitch to install"
      }}>{`upgrading my linux box to Ubuntu Natty Narwhal`}</a>{` and mentioned that I hate the new user experience the system offers.`}</p>
    <p><a parentName="p" {...{
        "href": "#screenshots"
      }}>{`tl;dr --> I don't care, take me to the screenshots!`}</a></p>
    <p>{`I was wrong.`}</p>
    <p>{`It. Is. Fucking. Awesome.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/d026a04f42df6abd41f81f1c8330e244/1250c/ta9e5.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "52.91479820627802%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'211\\'%20viewBox=\\'0%200%20400%20211\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M5%201c2%203-1%207-4%205l-1%204c0%203%200%204%202%204v1c-3%200-3%2016%200%2017%203%200%203%203%200%203-3-1-3%2016%200%2016%203%201%204%204%201%204l-3-1v8c0%207%200%209%202%2010%203%201%203%203%200%203-2-1-2%200-2%2023s0%2023%202%2023h2l-2%201c-2%200-2%201-2%2014l1%2014v1c-1%201%200%201%202%201l4%201H0v58h401V111L400%205V0H202C34%200%204%200%205%201m78%2071c-9%204-5%2018%206%2017h6c1%202%202%200%202-6%200-10-6-15-14-11m77%200c-6%203-6%2011-1%2015%202%202%204%202%209%202%206%200%206%200%206-3v-6c0-8-6-12-14-8m76%201c-3%202-4%206-3%2011%202%204%205%205%2012%205h6v-6c0-7-1-9-4-11-4-2-8-2-11%201m79-2c-5%202-7%208-5%2013%202%204%2010%207%2012%205h6v-7c-1-5-1-7-3-9s-7-3-10-2M84%20133l-4%204c-1%202-4%203-5%200l-3%209c0%202%200%203%201%202%201-6%202-8%205-8l3-1%201-1%201%201v2l1%202-2-1h-1v2c-1%202-1%202%201%203h3l2%201%203-1c1-2%203-2%204-2l2-1%201-2c2-2%202%201%201%207-3%209-8%2010-16%205-5-3-6-3-5%200h2c1-1%201-1%201%201v1h1l2%202%203%202h3c-1%201%200%202%201%202l1%201h3l5-3c2-1%203-2%202-3-1%200-1-1%201-2l2-8c0-5%200-6-3-8-5-5-12-7-17-6m78%201c0%202-2%202-6%202l-6%201-1%2012v13h4c3%200%204%200%204%202l10%201h10v-5c0-5%200-6%202-6s2-1%202-10v-10l-10-1-9%201m148%200c-2%202-1%203%202%202%202%200%202%200%202%203l-2%207c-7%208-1%2018%209%2018s15-11%208-19c-3-2-4-3-8-3l-5-1c1-7-1-9-6-7m-77%205l-5%205v18c0%202%200%202%2014%202l14-1v-19l-5-5c-7-7-11-7-18%200m-69%208c0%201-1%202-4%201-7%200-9%201-9%206v3h20v-5l-1-5h-1l-1%202-2-1-1-2c-1-1-1%200-1%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d026a04f42df6abd41f81f1c8330e244/ca0a1/ta9e5.webp 223w", "/static/d026a04f42df6abd41f81f1c8330e244/75680/ta9e5.webp 445w", "/static/d026a04f42df6abd41f81f1c8330e244/8d1ba/ta9e5.webp 890w", "/static/d026a04f42df6abd41f81f1c8330e244/3126b/ta9e5.webp 1178w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d026a04f42df6abd41f81f1c8330e244/853b2/ta9e5.jpg 223w", "/static/d026a04f42df6abd41f81f1c8330e244/0a4fe/ta9e5.jpg 445w", "/static/d026a04f42df6abd41f81f1c8330e244/7f80b/ta9e5.jpg 890w", "/static/d026a04f42df6abd41f81f1c8330e244/1250c/ta9e5.jpg 1178w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d026a04f42df6abd41f81f1c8330e244/7f80b/ta9e5.jpg",
                "alt": "ta9e5",
                "title": "Ubuntu Launcher",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Ubuntu Launcher`}</figcaption>{`
  `}</figure></p>
    <p>{`But what I wanted to talk about today was how a bunch of opensource geeks have managed to beat the paragon of usability and App Stores and all things shiny and awesome when it comes to managing apps, installing software and so on.`}</p>
    <p>{`Lest anyone feel like donning me in feathers and tar and making me run through a desert, I do realize there's probably more to Canonical than being a bunch of opensource geeks, but that's besides the point.`}</p>
    <p>{`There are two parts to what Ubuntu has created that makes the experience of app management so awesome. The the package manager and the cool interface.`}</p>
    <p>{`Now `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Package_management_system",
        "title": "Package management system"
      }}>{`package managers`}</a>{` are nothing new to anyone who's ever used linux before ... for some strange reason, even though `}<a parentName="p" {...{
        "href": "http://www.kernel.org/",
        "title": "Linux"
      }}>{`Linux`}</a>{` has had several package managers and nobody can fathom using a distro without one for at least the past 20 years (debian's dpkg first came out in 1993) ... no other OS has `}<em parentName="p">{`ever`}</em>{` managed to use a package manager.`}</p>
    <h2 {...{
      "id": "getting-an-app-the-old-way"
    }}>{`Getting an App the old way`}</h2>
    <p>{`Installing an application on Windows and `}<a parentName="p" {...{
        "href": "http://www.apple.com/macosx/",
        "title": "Mac OS"
      }}>{`MacOS`}</a>{` usually goes something like this:`}</p>
    <ol>
      <li parentName="ol">{`Hmm, I need to do something`}</li>
      <li parentName="ol">{`Google for it`}</li>
      <li parentName="ol">{`Ask for recommendations on twitter`}</li>
      <li parentName="ol">{`Get a bunch of things you should try`}</li>
      <li parentName="ol">{`Start finding homepages of this stuff`}</li>
      <li parentName="ol">{`Download a bunch of stuff`}</li>
      <li parentName="ol">{`Your most authoritative friend in the field finally chimes in and tells you what you want`}</li>
      <li parentName="ol">{`Find the homepage for that`}</li>
      <li parentName="ol">{`Download it (and/or buy it somewhere)`}</li>
      <li parentName="ol">{`Install the damn thing`}</li>
      <li parentName="ol">{`Get fed up`}</li>
      <li parentName="ol">{`Do whatever it is you wanted to do tomorrow`}</li>
      <li parentName="ol">{`Come back tomorrow, go through twitter stream to find out what the app was called`}</li>
      <li parentName="ol">{`Launch the app`}</li>
      <li parentName="ol">{`Be happy`}</li>
    </ol>
    <p>{`Your average package manager makes the whole process a bit simpler, something like this:`}</p>
    <ol>
      <li parentName="ol">{`Hmm, I need to do something`}</li>
      <li parentName="ol">{`Google`}</li>
      <li parentName="ol">{`Asking for recommendations`}</li>
      <li parentName="ol">{`apt-get something`}</li>
      <li parentName="ol">{`Use it`}</li>
      <li parentName="ol">{`Get a better recommendation`}</li>
      <li parentName="ol">{`apt-get something-else-entirely`}</li>
      <li parentName="ol">{`Use that`}</li>
      <li parentName="ol">{`Be happy`}</li>
    </ol>
    <p>{`The most notable difference is that suddenly you have this authoritative source of applications where everything is available in a single place. Sure, if you have specific needs you might still have to visit a website or two, three, four, five to get the specific version of the package you need just in case the one your distro offers is too old ... but all in all, the process is much nicer.`}</p>
    <p>{`A lot more instant gratification. And as a geek who likes to pretend to be a normal user now and anon, instant gratification is `}<em parentName="p">{`awesome`}</em>{`.`}</p>
    <h2 {...{
      "id": "the-app-store-saves-the-day"
    }}>{`The `}<a parentName="h2" {...{
        "href": "http://www.apple.com/iphone/apps-for-iphone",
        "title": "App Store"
      }}>{`App Store`}</a>{` saves the day`}</h2>
    <p>{`Recently Apple has done some improvements and became more like Linux with its variety of App Stores, the one on `}<a parentName="p" {...{
        "href": "http://www.apple.com/ios",
        "title": "IOS (Apple)"
      }}>{`iOS`}</a>{` works pretty well, the one on MacOS is ... well it's just a dash bit strange to be honest. It doesn't `}<em parentName="p">{`feel right`}</em>{`. It isn't tightly integrated into the OS itself, it doesn't really offer anything to make me want to use it.`}</p>
    <p>{`And it just doesn't look very apple-y either. I don't know, it lacks a certain zing to it and I rarely if ever open it to install something. It just sort of sits there existing for the sake of existence.`}</p>
    <p>{`I think maybe what's lacking the most is the integration. When there are updates I simply don't find out about them until I randomly open the store ... and the fact it's even called a store doesn't really help my frugal sense of how software should operate at all. I feel a natural aversion to opening it before I even look at what it is because I know somebody will just try to shove stuff in my face and make me buy it.`}</p>
    <p>{`You know, sort of like `}<a parentName="p" {...{
        "href": "http://www.apple.com/itunes/",
        "title": "ITunes"
      }}>{`iTunes`}</a>{`.`}</p>
    <p>{`I dislike iTunes with the passion of a thousand virgins.`}</p>
    <p>{`Another big issue with the App Store that I have is that it only works for `}<a parentName="p" {...{
        "href": "http://friendfeed.com/weloveapps",
        "title": "Apps"
      }}>{`Apps`}</a>{`. What about all the other software I need on my computer? Sure, maybe I'm a bit of a pathological case being a developer and all, but still. Why do I need homebrew, fink, macports and so on? `}<em parentName="p">{`Why!?`}</em>{` I don't want all of that.`}</p>
    <p>{`But let's look at screenshots, screenshots are good.`}</p>
    <h2 {...{
      "id": "the-app-store-in-screenshots"
    }}>{`The App Store in screenshots`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e5b9c080ec4db3bf52b0f855afceb56a/2c5fd/56R8z.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "86.54708520179372%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'346\\'%20viewBox=\\'0%200%20400%20346\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20173v173h401V173L400%200c-2%200-2%2049-1%20200v145h-99v-6l-1-11v-5h-24l-24%201h-1l-1-1c-2%200-2%201-3%2017v5h-25v-10l-1-12-27-1-25%201-1%2011v11h-22c-20%200-22%200-23-2-1-4-2-4-8-4l-6%201c0%205%200%205-55%205H2V172a9943%209943%200%2000-2%201m9-95l1%2060h186l188-1%201-20V98h-79V64l3%202c3%202%203%202%205%201%203-5%201-8-5-8h-3l-1-21V18h-66c-37%200-66%200-65%201l4%204%204%205%202%203c-1%203%200%203%203%200%2015-15%2040%201%2031%2020l-2%204%204%205%209%2013-4-3-3-4-3-2c-1-2-3-3-3-2-1%200-4-2-3-3%200-1-1-1-3%201h-16c-1-1-4%202-10%207l-9%209%2012%2017%2011%2018h-35l-3-6-5-8c-1-1-2%200-9%206l-8%208h-36l19-18%2019-20a315%20315%200%2000-20-26h-2l-4%202-3%201-8%204%201-1v-2l-3%202-2%201-5%203-4%203c-2%200-5%202-11%209-9%208-8%205%202-8%204-6%2010-11%2019-17%206-5%2026-14%2032-15%205-2%209-4%2010-7l4-3c1-1-30-1-68-1H9v60m184-46c-5%204-5%203%201%206%204%203%205%203%207%202s2-1-2-2c-3%200-4%200-4-2s1-2%207-2c5%200%206%200%206%202l-2%203c-2%202-3%203-1%203s4%203%204%206%203%204%204%202l1-7c-1-5-1-6-5-9-3-3-3-4-2-4%201-1-1-1-4-1-5%200-6%200-10%203m-24%2019l-8%207-5-7-4-7h-14l-13%201c1%201%204%202%2014%202%2011%200%2013%200%2013%202%201%202%201%202-4%200h-20l8%2013%208%2012-14%2013a2493%202493%200%2001-20%2021l2-1%204-1%204-1%201-2h3l-3-1-2-1h1c2%200%205-2%205-4l3-1%204-2c2-2%202-2%203-1h2l3%202%201%202c-2%200-1%202%202%203%203%200%204%200%208-4l4-4%205%207%205%208c2%201%2021%200%2022-1l1%201%202%201c3%200%203-1-8-17l-10-15%203-3%202-3h-4c-6-1-5-3%201-4l3-2v-1c2-2%202%201%201%203l-2%202%202-1%203-2c1%201%202%200%204-2l4-4-3-3-3-5v-1l-1-3c-1-6-4-5-13%204m170%2013c0%202%200%202-1%200l-1-2-2%203c-2%203-2%2010%200%2013%202%201%208%202%209%201%200-1%201-2%203-1%205%202%205%206%201%206-2%200-2%200-1-2%202-1%201-2-2-2l-1%204c0%202%201%203%205%203s6-4%206-14c0-8-1-10-5-10l-4-1-4-1c-3%200-3%200-3%203M118%20204c-2%200-3%201-3%202l3-1%205-1h4l-4%201-7%203c-2%202-2%202-2%200%201-3%200-2-1%201-3%206-2%2015%201%2015%202%200%202%200%201%201l-1%204c-1%202-1%202%202%202l3-1h19l1-5c0-7%200-7-1-6l-1-2c0-3-4-11-6-12-4-3-9-3-13-1m-97%200l-2%202-2%201h2c3%200%202%202-1%202-4%200-5%202-3%204%201%201%2022%202%2025%200%204-1%202-4-1-4-4%200-5-2-2-2h3l-3-1-2-2c1-1%200-1-1-1l-2%201H21m195%202c-3%201-3%203-2%204l4-2%204-2%203%201%201%202%201%202v3l-1%206c0%206-1%207-7%206l-6-2-2-1c-1%201%203%203%207%204%202%200%203%201%203%202%200%202%201%201%204-1l3-2c2%200%206-4%206-5h-1c-2%202-3%201-3-2l-1-3v-2c2-5%202-8%201-8h-14m-7%2037c-1%202-2%204-1%206%200%203%200%203%207%203l6%201%202%203c2%200%202%200%200%202v2l1%201%201%202v2c-2%204-1%205%204%205%206%200%208-2%208-8%200-5-1-6-3-4-2%201-2%201-1%204s1%203-1%203h-2c0%202-2%201-2-1l2-3%201-1-2-2c-4-1-3-10%200-11%203%200%207%202%207%205%201%201%201%200%201-2%200-9%200-9-15-9-11%200-12%200-13%202M14%20256l1%2013h27v-27H14v14m1-9l1%206%201%203%201-4v-4l4%201%204-1%201-2%201%201c0%203%206%202%207%200v-2l1%202c1%201%201%201%201-1s0-2-11-2H15v3m107-2c-1%202-4%203-5%201-2-1-2-1-3%202l-1%204c-2%200-1%204%201%207%201%204%205%207%205%206l2%201c1%200%201%201-1%201-1%201-1%201%202%201h7c2%200%202-1%201-1s-2%200-1-1l2-1c1%201%201%200%202-1l1-1%201-2%201-3c2-2%202-2%201-3l-2-1v2h-2c0-2-3-1-3%201l-2-1-3-2-1-1c1-2%201-2%205-1%201%201%202%201%202-1l2-1c2%201%203%201%202-1%200-2%200-2-1-1h-2c-2-1-2-1-2%201h-1l-1-2-1-1c1-2-3-3-5-1M17%20282l1%204%201%204c-1%201%201%2011%202%2013l3%201%203%202c2%204%208%202%208-2%200-2-2-3-5-2l-3-1c-1-1%204-2%2010-2%202%200%203%200%204-2%200-4-1-6-2-4l-3%202-4%201c-1%202-2%201-4%200-3-4-4-6-4-9l-2-3-3-2h-2m106%2012l-1%204-2%204c-2%202-1%205%203%206%206%201%2010-3%206-7l-1-5v-2h-5m198%2017c-6%203-3%2012%203%2012s9-6%205-11c-3-2-4-3-8-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e5b9c080ec4db3bf52b0f855afceb56a/ca0a1/56R8z.webp 223w", "/static/e5b9c080ec4db3bf52b0f855afceb56a/75680/56R8z.webp 445w", "/static/e5b9c080ec4db3bf52b0f855afceb56a/8d1ba/56R8z.webp 890w", "/static/e5b9c080ec4db3bf52b0f855afceb56a/1e748/56R8z.webp 1006w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e5b9c080ec4db3bf52b0f855afceb56a/e92b6/56R8z.png 223w", "/static/e5b9c080ec4db3bf52b0f855afceb56a/e66bf/56R8z.png 445w", "/static/e5b9c080ec4db3bf52b0f855afceb56a/4ef49/56R8z.png 890w", "/static/e5b9c080ec4db3bf52b0f855afceb56a/2c5fd/56R8z.png 1006w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e5b9c080ec4db3bf52b0f855afceb56a/4ef49/56R8z.png",
                "alt": "56R8z",
                "title": "Apple AppStore",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Apple AppStore`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/49349a94f4e1548cf794841aacd07990/6acbf/vk2cU.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "85.20179372197309%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'340\\'%20viewBox=\\'0%200%20400%20340\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20170v170h200l193-1c-7%200-7%200-7-2s0-3-3-3h-5l-1%203%201%202H1V19h200a3978%203978%200%2001196%203h-2l-1%20144v145h3l3-1v15l1-155V0h-31l15%201h15v5c0%205-1%207-3%203%200-2%200-2-1%201l-1%203h-28c-25%200-28%200-29-2V8c1-2%203-2%2030-2h28c0-2-5-2-30-2s-26%200-28%202l-2%203c0%202-5%202-38%202h-38l1-2c2-3%202-6%200-6l-1%202h-1V3c1-1%201-1-1-1-4%201-5%202-2%202v1l-1%203v2l-1-3-1-2-1%203%201%203h-10c-9%200-10%200-9-2%202-1%202-1-1-4-4-3-7-2-5%201l2%203c2%201%201%202-1%201h-2V7c0-2%200-2-1%200-1%201-1%202-2%201h-2l2%202c2%201-2%201-9%201h-12V8c0-3-2-5-4-5-3%200-5%202-5%205s-1%203-15%203c-8%200-10-2-8-5V5l-2-2h-2l-3%202v1c2%202%201%204-2%205a60%2060%200%2001-18%200l-3-1c-1-2-1-3%202-4%202-1%202-1%201-2h-4l-2%202-2%201c2%204-1%204-41%204a856%20856%200%2001-41-2c0-5%200-4-1%200-1%203-1%203-6%203-4%200-4%200-4-3%200-4%200-4%205-4l-6-1-11%201-1%204-1%202-1-1-1-1c-1-3-5-3-6%200%200%203-2%203-2%200-1-4-6-4-7-1l-1%203v-1c0-2-2-4-4-4S4%207%204%209l-1%201-1%203c-1%204-1%203-1-4V1h157l158-1H0v170M397%2025c0%202%200%202-1%201a5467%205467%200%20002%20283l1-143a3880%203880%200%2000-2-141M207%2045l2%204%202%206c-1%203%209%2011%2012%2011%202%200%203%200%202-1-2-1-4-7-3-8v-4l-1-5%201-2%201%202%201%203v-3l1-3c1-1%200-1-1-1l-3%201h-2c-1-2-4-3-4-1l2%202%201%205c0%201-1%201-3-3-3-4-7-6-8-3M15%2047c-2%202-2%2021%200%2023%202%203%2023%203%2025%200%202-2%202-21%200-23-2-3-23-3-25%200m108%201l-6%202-5%201v10l1%209h4c2-1%204%200%206%201s2%201%203-1l6-3c7-1%207%200%205-7v-8c2%202%202-1%200-3-3-2-3-2-4%200l-2%205-2%202v-2c2-5%201-7-2-7l-4%201m85%2036v15l1%2013h28V84l-14-1-15%201M46%2088c1%202%2012%203%2012%201h1c3%202%2022%201%2022-1s-15-2-19-1h-1l-12%201h-1c1-1%200-2-1-2l-1%202m-32%201c-1%201-1%203%201%207l1%209c0%205%203%207%208%206l8-1c7%200%209-3%209-8-1-7-3-8-3-3%200%203%200%204-1%203s-1-1-1%202l1%203-1%201h-9l-6-1-1-3-4-10c0-5-1-6-2-5m10%202c-6%203-4%2012%203%2013%207%200%2010-8%204-12-3-2-4-2-7-1m89%201v4c-1%204%200%206%203%207l2%202%202%201%202%202c1%202%203%201%205-2l4-2c2%201%206-8%205-10-1-1-1%200-2%203s-2%204-4%205h-10c-5-1-7-4-4-6%202-1%201-4-3-5v1m-93%2031c-5%202-6%206-6%2017v10h27v-7c0-7-1-7-3-8-2%200-3%200-2%201%202%202-1%208-4%206v-1c2-1%201-7-1-8l-4-2-5-1v-5l1%201c0%203%202%203%204%202%203-2%203-4-1-5h-6m94%202l-1%2011c0%2014-1%2013%2012%2013h11v-4l1-10-1-10h-22m114%200l-18%202-1%2012v12h27v-27h-4l-4%201m-99%2039l-6%204-5%202c-6%202-9%2011-4%2016%2010%2011%2031-1%2022-12-3-3-3-5%201-8%202-2%202-2%201-4-2-2-4-1-9%202m-113%202c-2%201-2%203-2%207l-1%209c-1%208%200%208%2015%208%2011%200%2012%200%2013-2%202-3%200-13-2-15l-2-1v1l-1%201h-1l-1%201c1%201%200%202-1%202-1%201-1%200-1-1v-2l-1-5c0-6-10-9-15-3m95%2049v14h28v-28h-28v14m-97-12v7l1%205h12v-13h-6l-7%201m14%205l1%207h12v-12l-7-1h-6v6m186-3v6l1%205h15v-12c-1-1-15%200-16%201m-101%209c0%209%205%2014%2015%2014%205%200%205%200%201-1-4%200-4%200-4-3%200-2%200-3%202-3s3%202%201%202c-1%201%200%201%201%201%203%200%203-4-1-5h-11l-2-5-2-5v5m0%2027c-2%201-3%208-2%2016%201%2011%200%2011%2014%2011%2013%200%2014%200%2014-11%200-10%200-11-1-9h-1v-1l1-1v-1l-1-3c-2-2-2-2-3%200h-3c-2-2-15-3-18-1m106%201h-2v1l-1%201-2%201c0%202-1%203-2%203l1%201v1c-3%200-4%205-4%2011v4c-1-2-1-2-1%200%201%202%201%203%2010%202a229%20229%200%200016%200c-2%201-2%201%200%201%201%200%202-1%201-8v-10h-1c-3%200-3%200-1-1v-1l-2-1c0-1-1-1-1%201h-1c0-5-6-8-10-6m-201%207l-2%206c0%202%200%202-1-1s-1-3-1%202c0%207%201%208%2010%208%207%200%2010-2%209-6-1-2%200-1%204%202l4%203v-6c0-4%200-5-1-4%200%202-1%203-2%203h-3l-2-2c-1-2-1-2-1%200l-1%203-1-3c0-6-7-9-12-5m105%2035c-1%205-1%205%201%205%203-1%206%201%206%204-1%203-4%204-7%202-1-1-1-1%201-1l5-1c0-3-4-2-7%200-1%201-1%201-1-1%201-3%200-4-6-2-4%201-3%203%201%205%204%201%204%202%203%208v4l1-2h1l1-1c-1-1-1-1%200%200l1-1v-1c0%201%202%200%203-2%202-2%202-2%204-1l2%202h2v1c-1%201-1%201%201%201l3%201-1-1-1-1-2-4c-2-3-2-4%200-5v-2h1l1-1v-1c1%201%204-1%202-2h-5c-4%201-5%201-5-1-4-5-5-6-5-2M15%20302v5h10c11%200%2011%200%2011-6v-3H15v4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/49349a94f4e1548cf794841aacd07990/ca0a1/vk2cU.webp 223w", "/static/49349a94f4e1548cf794841aacd07990/75680/vk2cU.webp 445w", "/static/49349a94f4e1548cf794841aacd07990/8d1ba/vk2cU.webp 890w", "/static/49349a94f4e1548cf794841aacd07990/4ad2e/vk2cU.webp 1001w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/49349a94f4e1548cf794841aacd07990/e92b6/vk2cU.png 223w", "/static/49349a94f4e1548cf794841aacd07990/e66bf/vk2cU.png 445w", "/static/49349a94f4e1548cf794841aacd07990/4ef49/vk2cU.png 890w", "/static/49349a94f4e1548cf794841aacd07990/6acbf/vk2cU.png 1001w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/49349a94f4e1548cf794841aacd07990/4ef49/vk2cU.png",
                "alt": "vk2cU",
                "title": "Categories",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Categories`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/890c5caa0919c0c13ca111cc05d44253/6acbf/xSyhR.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "86.54708520179372%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'346\\'%20viewBox=\\'0%200%20400%20346\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M50%2049l-10%207-9%206c-12%205-16%2018-7%2027%2016%2016%2048%201%2038-18l-4-5-2-2%202-4%204-7c2%200%203-2%203-3%200-5-7-5-15-1m135%2023v23h5c6%200%2012-2%2016-6l3-3%204%203c3%203%2011%206%2018%206h4V48h-6l-7%201h5c4%200%206%200%204%201l-3%202c0%201-1%202-3%202l-4%201c0%202-4%201-5-1l-2%201c-2%202-2%202-6-1-5-4-11-6-18-6h-5v24m-49-22l4%201%205-1-4%201-5%202h-1c1-3-1-2-2%201l-1%2017c0%2016%200%2016%203%2019l2%203h34l2-3c3-3%203-3%203-20%200-22%201-21-22-21l-18%201m113%204c-1%201-7%2022-6%2024l1%201v1h3c2%200%202%200%201%201s-1%201%202%201h2c-1%201-1%201%202%201h1c-1%201-1%201%202%201h2c-1%201-1%201%202%201h2c-1%201-1%201%201%201h2l3%201h1c-1%201-1%201%202%201h2c-1%201-1%201%202%201h2c-1%201%200%201%202%201l3-1%201-1h1l2-12c3-9%203-10%202-12l-19-5a1617%201617%200%2001-21-5M89%2055l-1%204c0%203%200%203-4%203s-5%201-5%203l1%202%204%201%203-1-4-1c-4%200-4-2%201-3h4v6l1%206h8c11%200%2011%200%2011-7%200-5%200-5%204-5l4-1h-4c-4%200-4%200-4-2%200-6-1-6-10-6l-9%201m166%203l-1%205v2l9-1c9-1%2010%200%208%204-1%203-3%203-6%200l-3-2-3%201h-3c-4%202%202%207%208%207%204%200%205%200%205%202%200%203%201%204%205%203l4%201%202-4c2-7%202-8%201-8-2%201-4-2-3-4v-1l-2%201-2%201c-2%200-1-2%201-2l-6-3c-12-3-13-3-14-2m-102%205l-4%202c-3%200-6%202-6%204l-2%201-4%202c-3%203%200%204%2011%205%2017%201%2021%201%2023-1%203-3%201-6-2-7l-3-1c0-5-9-8-13-5m-39%2088c-3%201-4%203-4%2015%200%2015%200%2015%2015%2015s15%200%2015-15c0-12%200-13-4-15h-22m-99%202l-1%2013c0%2014%200%2014%2014%2014%2013%200%2013%200%2013-14l-1-12v2l-1%208c-1%205-4%206-7%203h-2l-1-3v-7c-1-2%200-2%204-3%204%200%204%200%203-1H15m199%207c0%205-1%207-3%207s-4%203-2%204c3%202%206-3%206-10%200-2%200-3%202-3l3-1c3-1%202%207-1%2010l-3%202c-1%200-4%206-3%207%201%204%206%205%2013%202%205-1%2011-7%2011-10%200-2-5-4-9-4l-5%201v-9l-5-1h-4v5m-86-1l-4%201-3%201-4%202-5%201-1%206c0%207%201%209%205%209%202%200%202%200%201-3%200-3%200-3%201-2l1%203c0%202%201%202%203%202h4l-1-6c-1-12-1-12%202-13%203%200%203%200%204%204l2%204-2-9h-3m-81%207c-1%203%202%204%2016%204s15-1%2015-3v-2H63l-16%201m97%200c-1%204%201%204%2016%204%2014%200%2017-1%2016-4-2-2-31-1-32%200m98%200c-1%203%202%204%2016%204s15-1%2015-3v-2h-15l-16%201M12%20205v15h30v-3l1-15v-12H12v15m195-10l1%206%201-1%201-1%201%203c0%202%200%202-1%201-1-2-2-1-2%201-1%204%200%205%206%204h5l-4%201c-8%200-8%201-8%206v5h31v-30h-31v5m-90-3v8l2-2h3v4l-1%202c-1-1-3%207-2%208s4-3%204-5l1-1v-3c0-4%201-5%203-2%202%204%201%209-2%2011-2%201-2%201%200%201h3l-3%202c-3%202-7%203-7%201l-1-1-1%202c1%202%203%202%209%202%2010%200%209%201%209-16v-11l-9-1-8%201m219%2011c-5%205-7%206-7%205%200-3-3-2-4%200l-4%202c-6%200-8%207-3%2012%204%205%2012%203%2012-2l3-5c3-3%203-4%200-4-2-1-2-1%204-7l5-7-6%206m-318%201l-4%204h3l4%201c0%202%205%204%208%203l4-2%204-1-2-1-4-4%202-1c1%200%202%200%201-1v-2c1-1%200-1-6-1s-7%200-10%205m29%201c-1%203%202%204%2011%204s10-1%2010-2c0-2-1-3-11-3l-10%201m97%201c-1%203%202%203%2017%203%2014%200%2015-1%2015-2%200-2-1-3-16-3-13%200-15%200-16%202m98-1c-1%203%201%204%2017%204%2014%200%2016%200%2016-2v-2c-1-2-33-1-33%200m-35%2039v15h30v-29l-15-1h-15v15m-92-11l-3%203v18l1-5c0-3%200-5%201-4l1%203v3l1-4c0-2%200-3%201-1%201%205%201%206%202%202l1-4v3c0%204%202%206%202%202%200-1%201-1%202%201%200%202%203%204%205%205%204%202%204%202%202%202h-4l3%201c3%200%204%200%206-6%202-5%204-13%202-10h-2l-1%201c1%202-3%207-4%205l-3-3c-3-2-3-2-1-2%205%200%207-1%206-4l1-4h-4c-5%200-6%200-5-2h-10m-68%2011c-2%204%200%204%2016%204%2014%200%2015-1%2015-2%200-2-1-3-16-3l-15%201m97%201c-1%202%202%203%2012%203%209%200%2010-1%2010-2%200-3-21-4-22-1m98-1c-2%204%200%204%2017%204%2016%200%2018%200%2016-4%200-2-33-2-33%200M12%20283v15h30v-3l1-15v-12H12v15m204-13c-13%207-10%2026%205%2028%2012%201%2020-11%2014-22-2-4-9-8-12-8l-7%202m-99%201c-6%204-9%2011-5%2018l3%205c2%200%201%202-2%202-6%200%201%202%208%202%2011%200%2018-6%2018-15%200-11-12-18-22-12m99%201c-5%203-6%206-6%2011%200%207%203%2010%204%204%201-5%203-3%203%203l1%206v-7c0-7%201-9%205-9%202%200%204%202%204%204s0%202%201%201c1-2%203%200%203%203s2%203%203%201v-13c-3-5-13-8-18-4m-93%202c-2%201-3%204-3%205%200%202-1%202-6%202-4%200-1%2010%204%2013%2013%208%2027-11%2015-20-4-4-7-4-10%200m-76%209c-3%203%200%204%2017%204%2016%200%2018-1%2016-4-2-1-31-2-33%200m97%200c-1%204%201%204%2016%204s17%200%2015-3c0-3-30-3-31-1m98%200c-3%203%200%204%2016%204h15v-2c0-2-1-3-15-3l-16%201M16%20313c-1%203-1%204%203%204%203%200%204%200%204-2l1-2v2l1%202%201-2%201-2v2c0%202%202%203%202%200h1l3%202v-2l3%201c1%203%204%201%204-2%200-4%200-5-3-3%200%201-2%202-4%201h-5c-1%200-2%200-1-1l-1-1-2%201h-1c0-2-2-1-2%202v3l-1-3c-1-4-3-4-4%200m111%202c-5%205-5%206-4%206l2%202c0%202%204%205%207%205%206%200%208-8%204-13-4-3-6-3-9%200m93%201l1%203-2-3c-3-3-4-3-1%202l1%204-1%201c-3%200-2%201%202%206%205%204%207%205%205%201-2-3-1-4%201-1l3%202-3-7c-1-1-1-1%201-2s2-1-3-5c-4-4-4-4-4-1m-195%203l-1%201c-3-2-5%2010-2%2012%202%202%2014%202%2014%201h1c3%202%203%201%203-7v-8h-7l-8%201m23%203l-1%202c0%202%201%202%2016%202%2017%200%2019-1%2017-3-1-2-31-3-32-1m97%200l-1%202c1%203%2034%203%2034%200l-1-2h-32m98%200l-1%202c0%202%201%202%2016%202h15v-2c0-2-1-3-15-3l-15%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/890c5caa0919c0c13ca111cc05d44253/ca0a1/xSyhR.webp 223w", "/static/890c5caa0919c0c13ca111cc05d44253/75680/xSyhR.webp 445w", "/static/890c5caa0919c0c13ca111cc05d44253/8d1ba/xSyhR.webp 890w", "/static/890c5caa0919c0c13ca111cc05d44253/4ad2e/xSyhR.webp 1001w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/890c5caa0919c0c13ca111cc05d44253/e92b6/xSyhR.png 223w", "/static/890c5caa0919c0c13ca111cc05d44253/e66bf/xSyhR.png 445w", "/static/890c5caa0919c0c13ca111cc05d44253/4ef49/xSyhR.png 890w", "/static/890c5caa0919c0c13ca111cc05d44253/6acbf/xSyhR.png 1001w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/890c5caa0919c0c13ca111cc05d44253/4ef49/xSyhR.png",
                "alt": "xSyhR",
                "title": "Listing",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Listing`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/0210736dc1a3b2f4bbc9511eb9843a36/46e51/VLO4k.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "84.75336322869954%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'339\\'%20viewBox=\\'0%200%20400%20339\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20170a5440%205440%200%20002%209V19h398v160l1%20160V0H0v170M2%206c0%203%200%203%201%202l1-2h25c1-1%201%200%201%201l1-1c1-2%201-2%2012-2s11%201%2012%203l1%201c0-2%201-2%2038-2%2035%200%2039%200%2038-1%200-3%204-3%206%200h2l3-1%202%201h19c2%200%203-1%203-2l1-1%201%201c0%203%2025%204%2026%201h8c0%202%202%202%2011%202l11%201c0%201%201%201%201-1%201-2%205-3%207-1l2%201h1c-1%202%2015%201%2017-1l6-3c4%200%205%200%206%202v2h65a844%20844%200%200170-2V2L201%201H2v5m340%202c2%201%203%204%201%204-3%200-4-2-4-3V7c-2%200-1%205%200%206%203%202%2055%201%2056-1V8c-1-1-3-2-28-2s-27%200-25%202M16%2066v6h6c7-1%208-1%207-9l-1-4H16v7m340-1v4h32v-8h-32v4m1%2030l-1%204v4h32v-8l-16-1-15%201M17%20110l-1%205c0%205%200%205%202%205l4%201c0%201%202%201%204-1%203-1%203-2%202-5l-1-5H17m88%2015\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0210736dc1a3b2f4bbc9511eb9843a36/ca0a1/VLO4k.webp 223w", "/static/0210736dc1a3b2f4bbc9511eb9843a36/75680/VLO4k.webp 445w", "/static/0210736dc1a3b2f4bbc9511eb9843a36/8d1ba/VLO4k.webp 890w", "/static/0210736dc1a3b2f4bbc9511eb9843a36/2f8da/VLO4k.webp 1003w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0210736dc1a3b2f4bbc9511eb9843a36/e92b6/VLO4k.png 223w", "/static/0210736dc1a3b2f4bbc9511eb9843a36/e66bf/VLO4k.png 445w", "/static/0210736dc1a3b2f4bbc9511eb9843a36/4ef49/VLO4k.png 890w", "/static/0210736dc1a3b2f4bbc9511eb9843a36/46e51/VLO4k.png 1003w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0210736dc1a3b2f4bbc9511eb9843a36/4ef49/VLO4k.png",
                "alt": "VLO4k",
                "title": "Old apps",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Old apps`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "the-ubuntu-software-center"
    }}>{`The `}<a parentName="h2" {...{
        "href": "https://wiki.ubuntu.com/SoftwareCenter",
        "title": "Ubuntu Software Center"
      }}>{`Ubuntu Software Center`}</a></h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "872px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/3aedc1fb3fa971cf7cc8aeffc327732b/65654/qe1Xr.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.98654708520179%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'243\\'%20viewBox=\\'0%200%20400%20243\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20122v122l1-105A617%20617%200%20013%2030c-3%200-3-8%200-10v-2l-2-2c0-2%204-2%20199-2h199l-1%2020a4100%204100%200%20003%2087V0H0v122m273%20121\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3aedc1fb3fa971cf7cc8aeffc327732b/ca0a1/qe1Xr.webp 223w", "/static/3aedc1fb3fa971cf7cc8aeffc327732b/75680/qe1Xr.webp 445w", "/static/3aedc1fb3fa971cf7cc8aeffc327732b/a8a2c/qe1Xr.webp 872w"],
                "sizes": "(max-width: 872px) 100vw, 872px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3aedc1fb3fa971cf7cc8aeffc327732b/e92b6/qe1Xr.png 223w", "/static/3aedc1fb3fa971cf7cc8aeffc327732b/e66bf/qe1Xr.png 445w", "/static/3aedc1fb3fa971cf7cc8aeffc327732b/65654/qe1Xr.png 872w"],
                "sizes": "(max-width: 872px) 100vw, 872px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3aedc1fb3fa971cf7cc8aeffc327732b/65654/qe1Xr.png",
                "alt": "qe1Xr",
                "title": "Ubuntu AppStore",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Ubuntu AppStore`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "872px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/a2e38cccb9ce96e6a7d194d479d1fd69/65654/zB1gB.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.98654708520179%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'243\\'%20viewBox=\\'0%200%20400%20243\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20122v122l1-105A617%20617%200%20013%2030c-3%200-3-8%200-10v-2l-2-2c0-2%204-2%20199-2h199v115a2419%202419%200%20002-8V0H0v122m137-56l-1%2010v4h17V70l-1-9-7-1h-8v6m80-1c-1%201-2%202-1%203%200%201%200%202-3%201l-6%202-2%202%202%203c3%205%208%204%2010-2h3c3%202%207-1%207-6%200-4-6-6-10-3m-71%2051l1%201%201%201-3-1v5c1%201%200%202-1%202-3%201-4%205-3%207%201%201%2010%202%2012%200%203-1%202-5%200-6-3-1-3-2-2-6v-4c-2-1-5-1-5%201m203%200l2%204%202%204-2%204c-3%204-2%204%201%204%202%200%203-1%205-4%204-5%204-4%200-9-3-4-8-6-8-3m8%200l3%204c2%204%203%203-2%2010-1%202-1%202%202%202%202%200%203-1%205-4%204-5%204-5%200-9-3-4-8-6-8-3m-87%20127\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a2e38cccb9ce96e6a7d194d479d1fd69/ca0a1/zB1gB.webp 223w", "/static/a2e38cccb9ce96e6a7d194d479d1fd69/75680/zB1gB.webp 445w", "/static/a2e38cccb9ce96e6a7d194d479d1fd69/a8a2c/zB1gB.webp 872w"],
                "sizes": "(max-width: 872px) 100vw, 872px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a2e38cccb9ce96e6a7d194d479d1fd69/e92b6/zB1gB.png 223w", "/static/a2e38cccb9ce96e6a7d194d479d1fd69/e66bf/zB1gB.png 445w", "/static/a2e38cccb9ce96e6a7d194d479d1fd69/65654/zB1gB.png 872w"],
                "sizes": "(max-width: 872px) 100vw, 872px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a2e38cccb9ce96e6a7d194d479d1fd69/65654/zB1gB.png",
                "alt": "zB1gB",
                "title": "Categories",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Categories`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "872px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/bce0e0f181998871315eedc69b5a9a1d/65654/DrKUU.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.98654708520179%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'243\\'%20viewBox=\\'0%200%20400%20243\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20122v121h401V0H0v122m0%200v121l200-1h199V64H105V32h145l147-1c2%200%202-2%202-9v-8H206C38%2014%2014%2014%2015%2015l2%206v4H8v-4c0-4%200-5%202-6%201-1%200-1-4-1H1V7L0%20122M40%2017c0%201-1%202-2%201l-2%201h-1v-1c1-1%201-1-1-1l-2%202%201%201v1c-2%201-2%201%202%201h6l1-2%201%201%202%202v-3c1%202%205%202%209%202l2-2h1c0%202%203%203%203%201%201-2%200-3-8-3l-8-1h-4m84%2035v9l21%201h19V52l-20-1-20%201m-16%2038l1%206h10V85l-6-1h-5v6m0%2018v5h11v-9l-6-1h-5v5m0%20111c0%205%201%205%203%205l2-1%201-1%201%201c-1%201%200%201%201%201s2%200%201-1l1-1c1%201%201%200%201-4%200-5-2-7-3-3h-1c0-1-1-2-4-2h-3v6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bce0e0f181998871315eedc69b5a9a1d/ca0a1/DrKUU.webp 223w", "/static/bce0e0f181998871315eedc69b5a9a1d/75680/DrKUU.webp 445w", "/static/bce0e0f181998871315eedc69b5a9a1d/a8a2c/DrKUU.webp 872w"],
                "sizes": "(max-width: 872px) 100vw, 872px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bce0e0f181998871315eedc69b5a9a1d/e92b6/DrKUU.png 223w", "/static/bce0e0f181998871315eedc69b5a9a1d/e66bf/DrKUU.png 445w", "/static/bce0e0f181998871315eedc69b5a9a1d/65654/DrKUU.png 872w"],
                "sizes": "(max-width: 872px) 100vw, 872px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/bce0e0f181998871315eedc69b5a9a1d/65654/DrKUU.png",
                "alt": "DrKUU",
                "title": "Listing",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Listing`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "400px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/04d29c8201ac28c5f7b5d7ae5da89f6b/e17e5/es2K2.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.53811659192825%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'243\\'%20viewBox=\\'0%200%20400%20243\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M1%201L0%20122v121h401V0H201L1%201M0%20122v121l200-1h199V14H101v12H1V13L0%20122m128-75l-3%201%202%202c4%202%204%208%200%2011l-3%202-3-2c-3-2-4-2-3%203%205%2016%2031%2014%2031-2%200-2%200-3-3-2-5%200-8-3-6-7l2-3c2%200%201-2-2-4-5-1-8-1-12%201m158%2081l-1%2038v38h52c48%200%2051-1%2051-2l-1-2-1-2s-1-2-3-2c-4-2-6-5-5-9%200-4%201-4%205%200l4%202%201-31v-31h-51l-51%201m49%2050c-2%202-8%203-11%201h-11v7c0%208%202%2010%205%206%202-2%206-3%209%200l2%201v-4c-1-4%200-6%204-5h5l3-1%205-2c1-1%201-1-2-1l-4-2c-1-2-4-2-5%200m14%201c-2%203-3%2013%200%2016%200%202%201%202%201%201%200-2%208-9%2010-9l4%201%205%201%204-1c1%201%201%200%201-1l-1-3-5-1-7-1-4-3c0-3-5-3-8%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/04d29c8201ac28c5f7b5d7ae5da89f6b/ca0a1/es2K2.webp 223w", "/static/04d29c8201ac28c5f7b5d7ae5da89f6b/7f61c/es2K2.webp 400w"],
                "sizes": "(max-width: 400px) 100vw, 400px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/04d29c8201ac28c5f7b5d7ae5da89f6b/e92b6/es2K2.png 223w", "/static/04d29c8201ac28c5f7b5d7ae5da89f6b/e17e5/es2K2.png 400w"],
                "sizes": "(max-width: 400px) 100vw, 400px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/04d29c8201ac28c5f7b5d7ae5da89f6b/e17e5/es2K2.png",
                "alt": "es2K2",
                "title": "Games",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Games`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "872px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/9d657ae31e1ab826347d1b6b4213d3c8/65654/FGAAv.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.98654708520179%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'243\\'%20viewBox=\\'0%200%20400%20243\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20122v121h401V0H0v122m0%200v121l200-1h199V14H1V7L0%20122m108-65c0%205%200%205%203%205l4%202c0%203%204%202%205%200%200-2%200-2-1-1l-3%202%201-3%202-6v-4h-11v5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9d657ae31e1ab826347d1b6b4213d3c8/ca0a1/FGAAv.webp 223w", "/static/9d657ae31e1ab826347d1b6b4213d3c8/75680/FGAAv.webp 445w", "/static/9d657ae31e1ab826347d1b6b4213d3c8/a8a2c/FGAAv.webp 872w"],
                "sizes": "(max-width: 872px) 100vw, 872px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9d657ae31e1ab826347d1b6b4213d3c8/e92b6/FGAAv.png 223w", "/static/9d657ae31e1ab826347d1b6b4213d3c8/e66bf/FGAAv.png 445w", "/static/9d657ae31e1ab826347d1b6b4213d3c8/65654/FGAAv.png 872w"],
                "sizes": "(max-width: 872px) 100vw, 872px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9d657ae31e1ab826347d1b6b4213d3c8/65654/FGAAv.png",
                "alt": "FGAAv",
                "title": "Installed",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Installed`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "comparing-discoverability"
    }}>{`Comparing discoverability`}</h2>
    <p>{`Let's pretend for a moment that both Apple and Ubuntu have solved the problem with package managers ... sort of. There is an almost sane way of installing new software on either OS.`}</p>
    <p>{`What about discoverability? How do I find apps that are already installed? What about apps that I might want but have no idea on how to find?`}</p>
    <p>{`Ubuntu's new Unity interface might finally provide an answer to `}<em parentName="p">{`that`}</em>{`.`}</p>
    <p>{`As much as crowdsourcing app suggestions is good and awesome, I think this might be better.`}</p>
    <p>{`Let me show you some screenshots of the Ubuntu app management and usage experience:`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/d026a04f42df6abd41f81f1c8330e244/1250c/ta9e5.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "52.91479820627802%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'211\\'%20viewBox=\\'0%200%20400%20211\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M5%201c2%203-1%207-4%205l-1%204c0%203%200%204%202%204v1c-3%200-3%2016%200%2017%203%200%203%203%200%203-3-1-3%2016%200%2016%203%201%204%204%201%204l-3-1v8c0%207%200%209%202%2010%203%201%203%203%200%203-2-1-2%200-2%2023s0%2023%202%2023h2l-2%201c-2%200-2%201-2%2014l1%2014v1c-1%201%200%201%202%201l4%201H0v58h401V111L400%205V0H202C34%200%204%200%205%201m78%2071c-9%204-5%2018%206%2017h6c1%202%202%200%202-6%200-10-6-15-14-11m77%200c-6%203-6%2011-1%2015%202%202%204%202%209%202%206%200%206%200%206-3v-6c0-8-6-12-14-8m76%201c-3%202-4%206-3%2011%202%204%205%205%2012%205h6v-6c0-7-1-9-4-11-4-2-8-2-11%201m79-2c-5%202-7%208-5%2013%202%204%2010%207%2012%205h6v-7c-1-5-1-7-3-9s-7-3-10-2M84%20133l-4%204c-1%202-4%203-5%200l-3%209c0%202%200%203%201%202%201-6%202-8%205-8l3-1%201-1%201%201v2l1%202-2-1h-1v2c-1%202-1%202%201%203h3l2%201%203-1c1-2%203-2%204-2l2-1%201-2c2-2%202%201%201%207-3%209-8%2010-16%205-5-3-6-3-5%200h2c1-1%201-1%201%201v1h1l2%202%203%202h3c-1%201%200%202%201%202l1%201h3l5-3c2-1%203-2%202-3-1%200-1-1%201-2l2-8c0-5%200-6-3-8-5-5-12-7-17-6m78%201c0%202-2%202-6%202l-6%201-1%2012v13h4c3%200%204%200%204%202l10%201h10v-5c0-5%200-6%202-6s2-1%202-10v-10l-10-1-9%201m148%200c-2%202-1%203%202%202%202%200%202%200%202%203l-2%207c-7%208-1%2018%209%2018s15-11%208-19c-3-2-4-3-8-3l-5-1c1-7-1-9-6-7m-77%205l-5%205v18c0%202%200%202%2014%202l14-1v-19l-5-5c-7-7-11-7-18%200m-69%208c0%201-1%202-4%201-7%200-9%201-9%206v3h20v-5l-1-5h-1l-1%202-2-1-1-2c-1-1-1%200-1%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d026a04f42df6abd41f81f1c8330e244/ca0a1/ta9e5.webp 223w", "/static/d026a04f42df6abd41f81f1c8330e244/75680/ta9e5.webp 445w", "/static/d026a04f42df6abd41f81f1c8330e244/8d1ba/ta9e5.webp 890w", "/static/d026a04f42df6abd41f81f1c8330e244/3126b/ta9e5.webp 1178w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d026a04f42df6abd41f81f1c8330e244/853b2/ta9e5.jpg 223w", "/static/d026a04f42df6abd41f81f1c8330e244/0a4fe/ta9e5.jpg 445w", "/static/d026a04f42df6abd41f81f1c8330e244/7f80b/ta9e5.jpg 890w", "/static/d026a04f42df6abd41f81f1c8330e244/1250c/ta9e5.jpg 1178w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d026a04f42df6abd41f81f1c8330e244/7f80b/ta9e5.jpg",
                "alt": "ta9e5",
                "title": "Launcher",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Launcher`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/5bd6e41a0d1a1f871c81712774999ebf/bcec7/JwBDf.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M1%207c-2%201%200%202%205%202l7%201c1%201%201%201-1%201-1%200-2%200-1%201l2%201c1-1%201%200%201%204l-1%205h-1l-1%202-1-2-1-3-1%203c1%202%201%202-3%202-5%200-5%200-5%203v3l6-1c6%200%208%201%205%203v2l1%206v5l-6-1c-6%200-6%200-6%202%200%203%200%203%204%203%2010%200%2011%200%2011%203%200%202-1%203-2%203l-1%205v4H1v-5c-1-3-1-2-1%203v8l3-1c3-1%2010%200%2011%201l1%207v6l-1-6c-1-6-2-8-3-6v2l1%206v5H7c-6%200-6%200-6-3-1-1-1-1-1%202v5h7l8%201v8c0%209%200%209-10%209l-5%201%206%201%208%201v2l-1%202-1%203-1%201%201%201c2-1%201%201%200%203-2%201-2%203-1%203l1-1%201-2%201%202c0%202-1%202-7%202s-7%200-7%202l7%201c7%200%2010%202%204%204H9l2%201c2%200%203%201%203%204l-1%204-1%202h2v1H8l-5%201c-2%200-3%200-3%202l8%201h7v17H8c-6%200-8%200-8%202l7%201c7%200%207%200%207%202%200%201%200%202-1%201l-2%201c-2%202-9%201-10-1-1-1-1%201-1%206l1%207h4l4%201H4c-3%200-4%200-4%202l7%201h7v3c0%202%200%203-1%202l-2-1v-1c2%200%202%200%201-1s-1-1-3%201l-4%202v3c2%201%201%204-2%204-4%200-4%202%200%204l4%201H3c-2%200-3%200-3%202l5%201c11-1%2010-1%2010%209v8h385V106l1-100H201L1%207m21%2014v10h362V11H22v10m1%200v9h360V12H23v9m30%2022c0%201%200%202%201%201h3c0-1%201-1%201%201h8c5-1%2012%200%2013%201s1%201%202-1c1-3%201-3-1-3-1%200-2%200-1-1H56l-1-1c-1%200-2%201-2%203m-1%2013l-2%206c-4%205-3%206%205%206%207%200%207%200%204-5l-3-6c-1-5-3-5-4-1m61%2055l-1%201-3%201h-1c-2-3-6%206-4%2010%200%202%201%203%205%203%208%200%2011-6%207-13-2-3-3-4-3-2m53%201l-2%201h-2c-2%200-2%200-2%206l2%206h6l5%201v-4l1-4c0-2%200-2-2-2l-3%201h-1l-3-1-2-1h3l1-1h1l5-2h-7m50%200c-1%201%203%203%206%203l3%201-5%201h-5v4l1%205h6c8%200%209-1%208-7%200-4-1-5-4-6-6-2-10-2-10-1m117%203l-2%205-2%203-1%203h7c8%200%208-1%205-5l-3-6c-1-5-3-5-4%200M11%20153l-6%201-1%202-1%201c-2-1-2%200-2%203v3h12v-5c0-4-1-7-2-5m154%2016l-1%202c0%202%200%202-1%201-1-3-3-1-3%205l1%207h5c7%200%207-1%206-10%200-6-2-7-4-2l-1%204-1-4-1-3m56%200l-1%202c0%202%200%202-1%201-1-3-2%200-2%205v7h12v-8c0-6-1-7-2-7l-2%202c-1%204-3%204-3%200l-1-2m50%207l1%209h15v-16l-8-1h-8v8m67-5c-2%204-3%204-3%201%200-2-1-3-2-3v2c0%202%200%202-1%201-2-2-3-1-3%205l1%207h11v-8c0-8-1-10-3-5m-232%201c-4%205-1%2011%205%2011%205%200%208-8%204-11-3-3-8-2-9%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5bd6e41a0d1a1f871c81712774999ebf/ca0a1/JwBDf.webp 223w", "/static/5bd6e41a0d1a1f871c81712774999ebf/75680/JwBDf.webp 445w", "/static/5bd6e41a0d1a1f871c81712774999ebf/8d1ba/JwBDf.webp 890w", "/static/5bd6e41a0d1a1f871c81712774999ebf/7592c/JwBDf.webp 1188w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5bd6e41a0d1a1f871c81712774999ebf/853b2/JwBDf.jpg 223w", "/static/5bd6e41a0d1a1f871c81712774999ebf/0a4fe/JwBDf.jpg 445w", "/static/5bd6e41a0d1a1f871c81712774999ebf/7f80b/JwBDf.jpg 890w", "/static/5bd6e41a0d1a1f871c81712774999ebf/bcec7/JwBDf.jpg 1188w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/5bd6e41a0d1a1f871c81712774999ebf/7f80b/JwBDf.jpg",
                "alt": "JwBDf",
                "title": "Category",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Category`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/bc32eaef36d8747848efa1bbf5ed571a/ad68d/e2xhM.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "57.399103139013455%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'230\\'%20viewBox=\\'0%200%20400%20230\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M7%202c2%203-4%206-6%202-1-1-1%200-1%203%200%205%200%205%203%206%204%201%205%201%201%201H0v8c0%208%200%208%202%208s5%202%205%204l-3%201-4-1v4l1%205v1l-1%203c0%203%200%204%202%203l4%202%202%203H0v8c0%207%200%208%202%208%201%200%203%200%204%202s1%202-2%202H0v14h4l5%201H0v12l1%2012%201%203c1%206%204%205%203-1l1-4v11l-4-1-2-2v32h5l5%201H0v57h4c3%200%204%200%202%201H4l2%202c2%201%202%201-2%201H0v9h4l5%201H4c-4%200-4%200-4%203v3h401V117L400%202V0H203C22%200%207%200%207%202m327%2022h-5v52l1%2052h16v-16h44V68l-1-44h-55M102%2056c-1%204%200%2011%201%2012l8%201h6V53h-7c-8%200-8%200-8%203m121-2l-4%201c-1%200-2%200-1%202l-1%202v4l1%202%201%201h5l1-1%203-2%202-3-1-3-2-2-3-1h-1m-62%202l-1%202-1%205%201%205%205-1c10%200%209%200%209-4l-1-5-2-2c0-2-1-2-5-2s-5%200-5%202m114%201l-2%205v4h8l7-1-3-9c-2-2-8-1-10%201M49%2057c-2%200-3%201-3%203-1%205-1%206%201%206l4%201%205%201h4V56h-4l-7%201m58%2057l-1%202-1-1-1-1-1%206%201%206h11v-7c-1-7-2-10-3-4l-2%203-1-3-1-3-1%202m178%200l-1%205c0%205%200%205-1%202%200-3%200-4-3-4-6-1-7%200-7%205%201%205%203%206%203%200l1-3v7h6c5%200%206-1%204-3v-3c1-3-1-8-2-6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bc32eaef36d8747848efa1bbf5ed571a/ca0a1/e2xhM.webp 223w", "/static/bc32eaef36d8747848efa1bbf5ed571a/75680/e2xhM.webp 445w", "/static/bc32eaef36d8747848efa1bbf5ed571a/8d1ba/e2xhM.webp 890w", "/static/bc32eaef36d8747848efa1bbf5ed571a/446b5/e2xhM.webp 1170w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bc32eaef36d8747848efa1bbf5ed571a/853b2/e2xhM.jpg 223w", "/static/bc32eaef36d8747848efa1bbf5ed571a/0a4fe/e2xhM.jpg 445w", "/static/bc32eaef36d8747848efa1bbf5ed571a/7f80b/e2xhM.jpg 890w", "/static/bc32eaef36d8747848efa1bbf5ed571a/ad68d/e2xhM.jpg 1170w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/bc32eaef36d8747848efa1bbf5ed571a/7f80b/e2xhM.jpg",
                "alt": "e2xhM",
                "title": "More",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`More`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/d2d28d380df9c000e4971339cf6f04fc/2edea/aJW3Z.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "25.56053811659193%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'103\\'%20viewBox=\\'0%200%20400%20103\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M1%207C0%208%202%208%204%208c7%200%207%201%207%2010l1%208H6c-7%200-8%202-2%202%207%200%208%202%208%2010v8l-6-1c-6%200-6%200-6%202s1%202%206%202h6v8c0%2010%200%2010-8%2010-6%200-5%202%202%202l6%201v16H7l-7%201c0%202%202%202%206%202l6%201v13h155a4444%204444%200%2000196%200%20266%20266%200%200036-1l-7-3c0-2-1-2-4-2h-4l4-1c8-1%2013-4%206-3v-1c3-2%204-2%204%200s1%201%202-2V47l1-41H201L1%207m19%204l-2%2016%201%204h369V11l-184-1-184%201m0%2010v9h366l1-2V13l-184-1H20v9m26%2020h-2l-4%201h-2c-1-2-3%201-3%203l6%201a119%20119%200%200023-1l2%201%202-2c0-2-1-2-7-2l-3-1-1-1-2%201-3%201-3-1-1-1-2%201m0%2016c-2%203-2%204-1%207%203%207%2014%205%2014-2%200-8-9-11-13-5m206%2039l-13%201%204%201%206%201h3c1-2%202-2%203-1h16c13%201%2031%200%2031-1%200-2-10-2-50-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d2d28d380df9c000e4971339cf6f04fc/ca0a1/aJW3Z.webp 223w", "/static/d2d28d380df9c000e4971339cf6f04fc/75680/aJW3Z.webp 445w", "/static/d2d28d380df9c000e4971339cf6f04fc/8d1ba/aJW3Z.webp 890w", "/static/d2d28d380df9c000e4971339cf6f04fc/3eff0/aJW3Z.webp 1167w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d2d28d380df9c000e4971339cf6f04fc/853b2/aJW3Z.jpg 223w", "/static/d2d28d380df9c000e4971339cf6f04fc/0a4fe/aJW3Z.jpg 445w", "/static/d2d28d380df9c000e4971339cf6f04fc/7f80b/aJW3Z.jpg 890w", "/static/d2d28d380df9c000e4971339cf6f04fc/2edea/aJW3Z.jpg 1167w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d2d28d380df9c000e4971339cf6f04fc/7f80b/aJW3Z.jpg",
                "alt": "aJW3Z",
                "title": "Quick way",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Quick way`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "apples-offering-somehow-just-doesnt-come-close"
    }}>{`Apple's offering somehow just doesn't come close`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "752px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/cdd8a2e97f54718b1630cc956b508836/442cb/6Yg5W.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "61.43497757847533%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'246\\'%20viewBox=\\'0%200%20400%20246\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20123v123h401V0H0v123m0%201l1%20117%201-6h5l5%201h1l192-1h193v2c1%202%201%202%201%200v-3H200a7357%207357%200%2001-186-3c0-2%205-1%207%201h2l375%201a2344%202344%200%2000-1-185c-3%202-5%201-5-6-1-7%200-9%204-9a1785%201785%200%2000-196-3H1v-5L3%207c0%202%200%202%201-1%201-4%208-5%209%200%200%202%201%203%202%203%201%201%201%201%201-1-1-2%201-5%204-5s3%200%204%203c0%203%202%204%203%200s7-4%208%200v3h69l68%201c1%201%201%200%201-3V3h4c5%201%206%202%206%204s0%202%201%200c1-3%204-4%204-1h1l4-1%204-1h2l10%201%202-1%202%201h6c5%200%206%201%206%202%201%202%204%202%2080%202h79V7c1-5%2012-5%2011%200%200%203%202%203%202%200l1%202c1%204%201%204%201-1V2L199%201H0v123M101%2015c-1%202%201%209%202%208l2-2c0-5%200-5%203-5l3%202%201%201%201%202c-1%201%200%201%204%201h4v-7l-10-1-10%201m166%200c-4%201-5%204-4%207l2%203h63c62%200%2064%200%2065-2%203-3%202-7-2-8H267m-12%2021c-3%203-4%208-2%209v4c-3%204-2%208%203%209%208%201%2012-3%208-9v-4c3-1-1-11-5-11l-4%202m-73%201l2%2021c1%201%2018-3%2019-4%201-2-2-12-4-11h-2l-1%202c-1%202-1%202-2%200s-1-2-1%200l-1%202v1l-1%201c-1%200-5-6-5-8%200-4-3-7-4-4m133%202c-1%201%202%202%2010%202%205%200%208%200%207%201l-5%202-8%201-6%201v10h23V40l-21-1m-196%205l-2%203c-2%202-1%203%203%203%202%200%203%201%203%202l4%201c2%200%203-1%203-2l4-1c2%200%203%200%203-2l-1-2-2-1-1-2-1%201-2%203h-2c0-3-2-2-3%200h-1l-1-1-2-1-1-2-1%201m-70%202c0%202%200%202-1%201l-2-1a247%20247%200%2000-23%201c0%202%201%202%2014%203l13-1h2l-1-4c-2-1-2-1-2%201m35%205l-1%2031v29H1v11h82v15c0%2015%201%2018%204%2018%205%200%205%201%205-53l-1-52c-2-2-6-1-7%201m4%2050a511%20511%200%20002%201%20487%20487%200%2000-2-1m160-7l-1%2011v9h23V95h-7l-7-1h-8m-114%202l-11%202h-8v16h12c13%200%2013%200%2011-11v-8l-4%201m67%200l-11%202h-9v16h11l12-1V95l-3%201m129%200l-7%201-6%201h-4v15l12%201h11V95l-6%201m-73%202l-5%201c-4%200-4%200-4%204%200%203%200%203%201%201l3-2%202-1%203-1c2%200%202%200%202%202-1%203%200%203%206%202%204%200%204%200%204-4v-3h-6l-6%201M55%20125l-3%201H24l-1%202c0%202%201%202%205%201h19l7%201c6%200%206%200%206-2l-1-3h-4m-21%2011h-6c-3%200-4%200-5%202%200%202%201%203%202%201h38l1%201h1l2%201%201-2c0-3-1-3-9-3a7569%207569%200%2000-25%200m9%2011l-10%201c-9%200-11%200-9%203h14l11-1h1l2%201%201-1%202-1%201%202c0%201%202%202%202%200h5l3-1h4c2-1%202-1%202%201%201%201%201%201%202-1%202-3%203-3-17-3H43m210%204c-10%205-9%2019%201%2023%2011%204%2021-8%2016-18-4-6-10-8-17-5m-138%201c-2%203-1%2020%200%2021h23l1-12v-10l-12-1c-10%200-12%200-12%202m65%2011v12h26v-16l-1-9h-25v13m-156-5v3h29c1-3%200-3-2-4l-4%202h-2c0-1-3-2-4-1H24m-1%2010c0%203%201%205%202%203h17l3%201%204-1h1l1%201h1l2%201%201-2c0-3-1-3-14-3l-4%201h-1c0-2%200-2-2-1H23m1%2021l-1%202c0%202%201%202%208%202l8-1h1c1%201%206%202%208%200h1l3%201c2%200%203%200%203-2s-1-2-14-2H24m100%2021l-2%204c1%203-1%206-2%204l-2%201c-2%202-2%202%208%202s10%200%208-2c-1-1-2-2-1-4%201-6-6-9-9-5m60-1l-1%207c0%205%200%205%203%205s6-2%206-4v-3c1-2%201-2%204%201%204%203%205%202%205-3v-3l-8-1-9%201m131%200c-2%201-2%203%200%208l1%204h8c6%200%208%200%207-1h1l3%201v-1l-3-2-4-3-4-4c-1-3-5-3-9-2m-60%201c-3%201-6%204-7%208-1%203-1%203%202%203l2-1%201-1%204-3c1-2%201-2-1-4-1-1-1-1%203-1%203%200%203%200%202%201-2%200-2%200%200%204v4l1%201%201-1h2l3%201c2%200%202%200%201-3-2-7-9-10-14-8m-146%2016c0%203%200%203%207%203l7-1h1l7%201c6%200%207%200%207-2s-3-3-5-2h-22l-1-1-1%202m60%200v2l3%201h4l1%201%2011-1%2010-1h1l2%201%202-2c0-2-1-2-5-2h-27c0-2-2-1-2%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cdd8a2e97f54718b1630cc956b508836/ca0a1/6Yg5W.webp 223w", "/static/cdd8a2e97f54718b1630cc956b508836/75680/6Yg5W.webp 445w", "/static/cdd8a2e97f54718b1630cc956b508836/8cb39/6Yg5W.webp 752w"],
                "sizes": "(max-width: 752px) 100vw, 752px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cdd8a2e97f54718b1630cc956b508836/e92b6/6Yg5W.png 223w", "/static/cdd8a2e97f54718b1630cc956b508836/e66bf/6Yg5W.png 445w", "/static/cdd8a2e97f54718b1630cc956b508836/442cb/6Yg5W.png 752w"],
                "sizes": "(max-width: 752px) 100vw, 752px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cdd8a2e97f54718b1630cc956b508836/442cb/6Yg5W.png",
                "alt": "6Yg5W",
                "title": "Applications",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Applications`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "377px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/a34a82229445d0591b17b731327c60f2/6146e/pIqhj.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "65.47085201793722%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'261\\'%20viewBox=\\'0%200%20400%20261\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20100c0%20110%201%20137%204%20140%201%202%206%203%209%201h3c3%204-6%207-12%205l-4-1v16h30v-11h342v11h29V0h-8c-8%200-9%201-6%203%203%203%207%2015%204%2015h-1l1%202h-4l-2-1c-3-2-10-2-71-2l-64-1-1-9V0h-9l3%207%204%208c1%202%201%202-5%202h-6v-5c0-4%201-4%203-4s3-1%201-2l-1-4V0H0v100m285-33v8l-7%203-8%203c-2%202-4%201-9-4-3-4-6-6-7-6l-6%206-6%206%206%206%207%206-3%206-4%209v3h-18v17h18l1%205%203%209%203%204-7%206-6%207%206%205%206%206%207-6%207-6%203%203%209%203%205%201v18h17v-18h3l9-4%206-3%206%206%206%206c2%200%2012-10%2012-11l-6-7-5-6%202-5%204-8%201-4%208-1h9v-17h-18v-3l-3-9-3-6%205-6c7-7%207-7%202-12-8-7-7-7-15%200l-7%207-5-2c-4-2-5-3-3-3%201-1%200-1-3-2l-5-1V58h-17v9M62%2097c-16%2035%203%2075%2041%2084%2011%202%2016%202%2024%201%2028-6%2047-30%2047-58%200-10%200-13-4-23l-1-4h-31c-29%200-31%201-35%203-9%205-14%2014-14%2024%200%207-1%206-12-15L66%2091l-4%206m225%202l-8%205c-11%209-11%2024-1%2034l2%204c-1%200-1%201%201%201%204%202%2018%202%2023-1%2014-7%2017-25%206-37-7-7-14-8-23-6M93%20125c2%2027%2041%2028%2044%201%200-3%200-4-1-3-2%209-40%209-42%200-1-2-1-2-1%202m-7%2070c-2%202-1%207%201%208%201%201%201%201-1%201-3%200-2%202%201%203%202%200%202%201%202%205%200%205%200%205%203%205s3%200%203-3%200-3%204-3%208%203%208%205l3%201c2%200%202%200%202-3%200-2-1-3-7-8-1-1-4-2-9-2-3%200-6%200-5-1l2-1h-3c-1%200-2%200-2-2-1-3%200-4%202-4h2c0-2-4-2-6-1m36%2012l-1%205c0%205%200%205%203%205s3%200%203-3v-3h8c7%200%207%200%207-2s-1-3-10-3l-10%201m78%2025v6l2-5v-3l1%203c0%202%201%203%205%203%203%200%204%200%204-2h1c0%203%205%203%205%200%201-2%200-3-1-3v2l-1%202-1-2c0-3-6-6-10-4h-3c-1-1-1%200-2%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a34a82229445d0591b17b731327c60f2/ca0a1/pIqhj.webp 223w", "/static/a34a82229445d0591b17b731327c60f2/de9a6/pIqhj.webp 377w"],
                "sizes": "(max-width: 377px) 100vw, 377px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a34a82229445d0591b17b731327c60f2/e92b6/pIqhj.png 223w", "/static/a34a82229445d0591b17b731327c60f2/6146e/pIqhj.png 377w"],
                "sizes": "(max-width: 377px) 100vw, 377px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a34a82229445d0591b17b731327c60f2/6146e/pIqhj.png",
                "alt": "pIqhj",
                "title": "Quicksilver",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Quicksilver`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "conclusion"
    }}>{`Conclusion`}</h2>
    <p>{`All in all, I think Ubuntu has made a great leap to making the whole experience of using third party software much `}<em parentName="p">{`much`}</em>{` easier on the palate. There's still a long way to go and a bunch of geeks are already complaining that the whole interface sucks, but they keep forgetting just how much it sucks for everybody else who isn't using linux. We're just spoiled.`}</p>
    <p>{`Of course there is still a long way to go and the new interface does have its issues. There's also a big chance that cometh MacOS 10.7 everything might change. The App Store was meant for the new version after all and the fact we're even allowed to use it already is supposed to be a grace of the Gods and so on.`}</p>
    <p>{`We'll see, I really hope they come even close to Ubuntu Natty Narwhal because my laptop is (and always will be) running a Mac OS.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://news.slashdot.org/story/11/04/29/1357225/Is-Canonical-the-Next-Apple"
        }}>{`Is Canonical the Next Apple?`}</a>{` (news.slashdot.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.engadget.com/2011/04/28/ubuntu-11-04-natty-narwhal-brings-new-unity-ui-controversy-to/?icid=zemanta"
        }}>{`Ubuntu 11.04 'Natty Narwhal' brings new Unity UI, controversy to the desktop`}</a>{` (engadget.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.linuxfordevices.com/c/a/News/Ubuntu-1104-final-released/?kc=rss"
        }}>{`Ubuntu 11.04 out, awaits Unity verdict`}</a>{` (linuxfordevices.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.omgubuntu.co.uk/2011/04/using-elementary-os-or-other-ubuntu-derivatives-dont-upgrade-to-natty/"
        }}>{`Using Elementary OS (or other Ubuntu derivatives)? Don't upgrade to Natty!`}</a>{` (omgubuntu.co.uk)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=15a39502-5bcf-409e-8876-8ad78d4f840d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      